import { render } from "./SitePages.vue?vue&type=template&id=3ce7f344"
import script from "./SitePages.vue?vue&type=script&setup=true&lang=js"
export * from "./SitePages.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SitePages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ce7f344"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ce7f344', __exports__)) {
    api.reload('3ce7f344', __exports__)
  }
  
  module.hot.accept("./SitePages.vue?vue&type=template&id=3ce7f344", () => {
    api.rerender('3ce7f344', render)
  })

}


export default __exports__